import styled from "styled-components";

const ColorPickerWrapper = styled.div`
  position: absolute;
  z-index: 100;
  top: -250px;
`;

export default ColorPickerWrapper;
